import { useCallback, useState } from 'react';
import type { MobileGridViewMode } from './GridViewToggle';

export function useMobileGridView(defaultMode: MobileGridViewMode = 'grid') {
  const [mobileViewMode, setMobileViewMode] = useState<MobileGridViewMode>(defaultMode);

  const toggleMobileViewMode = useCallback(() => {
    setMobileViewMode((prev) => (prev === 'grid' ? 'card' : 'grid'));
  }, []);

  const viewModeClass = ` grid-view--${mobileViewMode}`;

  return { mobileViewMode, toggleMobileViewMode, viewModeClass };
}
